import React, { useEffect, useState } from "react";
import { addFactChecking } from "../../HTTP/articles";

export const GenerateMultiFactChecking = ({ articleLinks, setShowPopUpFactChecking, addReview }) => {
  const [processing, setProcessing] = useState(true);
  const [processedArticles, setProcessedArticles] = useState(0);
  const [totalArticles, setTotalArticles] = useState(0);

  // State pour éviter de relancer le traitement
  const [hasStartedProcessing, setHasStartedProcessing] = useState(false);

  // Lancer le traitement des articles au chargement du composant
  useEffect(() => {
    if (articleLinks && articleLinks.length > 0 && !hasStartedProcessing) {
      setHasStartedProcessing(true);
      const processArticles = async () => {
        console.log("Démarrage du traitement des articles");
        setProcessing(true);
        setTotalArticles(articleLinks.length);
        
        try {
          // Traitement séquentiel des articles
          for (let i = 0; i < articleLinks.length; i++) {
            const link = articleLinks[i];
            console.log(`Traitement de l'article ${i + 1}/${articleLinks.length}:`, link);
            
            try {

              // Après avoir reçu le résultat, afficher sa structure pour débogage
              const result = await addFactChecking(link);
              console.log("Structure du résultat pour l'article:", result);
              
              setProcessedArticles(i + 1);
            } catch (error) {
              console.error(`Erreur lors du traitement de l'article ${link}:`, error);
              
              // Mettre à jour le statut comme échoué
              
              setProcessedArticles(i + 1);
            }
          }
          
          console.log("Tous les articles ont été traités");
          setProcessing(false);
        } catch (error) {
          console.error("Erreur globale lors du traitement des articles:", error);
          setProcessing(false);
        }
      };
      processArticles();
    }
  }, [articleLinks, hasStartedProcessing, ]);

  // Calculer la progression
  const progress = totalArticles > 0 ? Math.round((processedArticles / totalArticles) * 100) : 0;
  
  return (
    <div 
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 notranslate"
        translate="no"
      >
      <div className="bg-gray-800 text-white rounded-lg shadow-md overflow-hidden max-w-4xl w-full max-h-screen">
        <div className="flex flex-col h-full">
          <div className="p-4 overflow-y-auto">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-lg font-semibold">Fact-check ({articleLinks.length} articles)</h3>
              <button 
                onClick={() => setShowPopUpFactChecking(false)}
                className="text-gray-400 hover:text-white"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>
            
            {/* Barre de progression */}
            <div className="mb-4">
              <div className="mt-2 w-full bg-gray-700 rounded-full h-4">
                <div 
                  className="bg-blue-500 h-4 rounded-full transition-all duration-300 ease-in-out" 
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <p className="text-center text-sm mt-1">
                {progress}%
              </p>
            </div>
            
            {/* Boutons d'action */}
            <div className="flex gap-2">
              {processing ? (
                <button
                  disabled
                  className="bg-blue-500 opacity-70 text-white font-bold py-2 px-4 rounded flex-1 flex items-center justify-center"
                >
                  <span className="animate-spin h-4 w-4 border-t-2 border-b-2 border-white rounded-full mr-2"></span>
                </button>
              ) : (
                <button
                  onClick={() => {setShowPopUpFactChecking(false); addReview()}}
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded flex-1"
                >
                  OK
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};